import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNotificationStore = defineStore('notification', () => {
  const message = ref('');
  const show = ref(false);
  const color = ref('error');

  const notify = (msg: string, notifColor = 'error') => {
    message.value = msg;
    color.value = notifColor;
    show.value = true;
  };

  return { message, show, color, notify };
});
